import { indexArray } from '../utils'
import type { AppManifest, AppManifests } from '../stateTypes'

export { indexTsgTree } from './indexTsgTree'
export { indexTsgInstances } from './indexTsgInstances'
export { indexSupportAccounts } from './indexSupportAccounts'
export type { ReadonlyTsgTree, TsgTree, Tsg } from './indexTsgTree'
export type { ReadonlyTsgInstances, TsgInstances, Instance, Association, TsgInstanceError } from './indexTsgInstances'

export const indexAppManifests = (apps: AppManifest[] | undefined): AppManifests => {
  if (!apps || (Array.isArray(apps) && apps.length === 0)) {
    const indexedApps = indexArray<AppManifest>([], 'app_id')
    Object.defineProperties(indexedApps, {
      getDisplayName: {
        value: (appId: string | undefined) => undefined
      }
    })
    return indexedApps as unknown as AppManifests
  }
  if (!Array.isArray(apps)) {
    return indexAppManifests.fromError(new Error('apps is not an array'))
  }
  const indexedApps = indexArray<AppManifest>(apps, 'app_id')
  Object.defineProperties(indexedApps, {
    getDisplayName: {
      value: (appId: string | undefined) => (
        (appId && indexedApps.get(appId)?.display_name) || undefined
      )
    }
  })
  return indexedApps as unknown as AppManifests
}
indexAppManifests.fromError = (error: Error) => {
  const apps = indexAppManifests(undefined)
  apps.error = error
  return apps
}
